import moment from 'moment';
import { RosteredShiftsCollectionReducerState } from './types';

export const getDefaultState = (): RosteredShiftsCollectionReducerState => ({
  rosteredShifts: {},
  site_id: '',
  from: moment(),
  to: moment(),
});
